import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getPrivileges(): Promise<any> {
  return await axiosInstance.get('/privileges', getDefaultRequestConfig());
}
